module.exports = __webpack_public_path__ + "static/media/svg.155ae750.svg";